export default {
    state: {
        order:{}
    },
    mutations: {
        loadOrder(state, payLoad) {
            state.order = payLoad
        }
    },
    actions: {
        async loadOrder(context, payLoad) {
            console.log(payLoad)
            await context.commit('loadOrder', payLoad)
        }
    },
    getters: {
        order(state) {
            console.log('2')
            return state.order;
        },
    },
    modules: {
      
    }
}